/**
 * TourVideo — HTML5 video player para pasos del Product Tour
 * Usado por TourTooltip cuando step.videoFallback !== null y la página está vacía.
 *
 * Convención naming vídeos: /videos/tour/{domain}_{id}.mp4
 * Ejemplos: /videos/tour/dashboard_overview.mp4, /videos/tour/alerts_triage.mp4
 */

import React, { useRef, useState } from 'react';
import { WarningCircle } from '@phosphor-icons/react';

const TourVideo = ({ src, poster, onEnded }) => {
  const videoRef = useRef(null);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
  };

  const handleEnded = () => {
    if (onEnded) onEnded();
  };

  if (hasError) {
    return (
      <div
        className="flex items-center gap-2 px-3 py-2.5 rounded-md bg-slate-800/60 border border-white/[0.06] text-[12px] text-slate-400"
        role="alert"
      >
        <WarningCircle className="h-4 w-4 shrink-0 text-cyan-400/70" weight="regular" aria-hidden="true" />
        <span>Vídeo no disponible — continúa al siguiente paso</span>
      </div>
    );
  }

  return (
    <div
      className="w-full overflow-hidden rounded-md border border-cyan-500/[0.18]"
      style={{ maxWidth: '480px', aspectRatio: '16 / 9' }}
    >
      <video
        ref={videoRef}
        src={src}
        poster={poster}
        autoPlay
        muted
        playsInline
        controls
        onError={handleError}
        onEnded={handleEnded}
        className="w-full h-full object-cover"
        aria-label="Vídeo demostrativo del paso del tour"
      />
    </div>
  );
};

export { TourVideo };
export default TourVideo;
